import template from 'product-messages.j2';

import { mDom } from '@core/js/utils/renderUtils';

import { generate } from '@core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';

import { scrollToElement } from '@core/js/utils/scrollUtils';
import { openAccordionTab } from '@core/js/uiSupport/accordion';

export function attachEvents(store) {

    $(document).on(this.scopedEvent('click'), '.js-product-message__info--flat-rate, .js-returns-restocking-message', (e) => {
        e.preventDefault();
        scrollToElement($('.js-product-details__shipping-header'));
        openAccordionTab('.js-product-details__shipping-header', store);
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .js-product-message',
        watch: ['product.productMessages', 'product.productBopis'],
        attachEvents: attachEvents,
        template: template,
        name: 'productMessagesComponent',
        forFamilyProduct: false,
        onStateChange: onStateChange,
        renderType: mDom
    };

    return generate(config, store, overrides);
}
